
<div class="Dashboard">
    <AppNavigation @navigation-toggle="handleNavigationToggle" />
    <Skeleton v-if="!hasFinishedLoading" />

    <div class="Wrap">
        <Infobox
            v-if="!userVerified"
            :hasCloseButton="false"
            title="Email Bestätigen"
            message="Sie haben eine Bestätigungs-E-Mail erhalten. Bitte klicken Sie auf den Link in dieser E-Mail, um Ihre Email-Adresse zu bestätigen."
        >
            <div class="EmailVerifyActions">
                <Button
                    variant="plain"
                    :isLoading="isLoadingVerifyEmail"
                    @onClick="handleVerifyEmailClick"
                    size="small"
                >
                    Email Ändern
                </Button>
                <Button
                    size="small"
                    :isLoading="isLoadingVerifyEmail"
                    @onClick="handleVerifyEmailClick"
                >
                    Email Erneut versenden
                </Button>
            </div>
        </Infobox>
        <router-view
            @onFinishLoading="handleFinishedLoading"
            @onComplete="handleOnboardingComplete"
            key="2"
        />
    </div>
    <Modal
        :show="isModalOpen"
        size="small"
        :title="'Hallo ' + contactPerson"
        :action="{ text: 'Los geht\'s', callback: closeModal }"
        :cancel="{ text: 'Abbrechen', callback: closeModal }"
        @onModalClose="closeModal"
    >
        <p>
            Willkommen in Ihrem neuen Dashboard ✨
            <br />
            <br />
            TaxiFusion hat nun ein neues Aussehen. Doch auch unter der Haube hat sich einiges
            getan! Neben einem schnelleren System haben wir auch neue Funktionen eingeführt. So
            können Sie Falschanmeldungen z.B. nun selbst korrigieren. 📝
            <br /><br />
            Auch eine neue Fahrer-App 📱 ist nun verfügbar! Diese finden Sie
            <a
                href="https://play.google.com/store/apps/details?id=com.taxifusion.driverApp"
                target="_blank"
                rel="noopener noreferrer"
                style="color: var(--color-blue-light); text-decoration: underline"
            >
                hier</a
            >
            für Android. <br /><br />
            Ihr TaxiFusion-Team 🙋🏻‍♂️
        </p>
    </Modal>
</div>
